export default "__VITE_ASSET__c8d6151a__"